import { FC } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useShallow } from "zustand/shallow";

import { useListBuilderStore } from "stores/list-builder.store";

interface Props {
  name: string;
}

export const SortingIndicator: FC<Props> = ({ name }): JSX.Element | null => {
  const { sortParams } = useListBuilderStore(
    useShallow(store => ({
      sortParams: store.sortParams
    }))
  );

  if (sortParams.by !== name) {
    return <ArrowDropUpIcon style={{ visibility: "hidden" }} />;
  }

  if (sortParams.order === "asc") {
    return <ArrowDropUpIcon />;
  } else {
    return <ArrowDropDownIcon />;
  }
};
